// Module
var code = "<img data-bind=\"attr: { src: preview, alt: alt }\">\n";
// Exports
module.exports = code;